export default {
  clean: () => import("/tmp/build_2c5fd183/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/tmp/build_2c5fd183/layouts/default.vue").then(m => m.default || m)
}